module.exports = __webpack_public_path__ + "media/assets/images/blog/almater_nosco-c81b0566d94c107264e96f9887333ff8.jpg";